import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import MortgageReadyChecklistPage from "@/pages/tools/MortgageReadyChecklist";

export const Route = createFileRoute("/tools/mortgage-ready-checklist")({
  head: () => seoHead("/tools/mortgage-ready-checklist"),
  component: MortgageReadyChecklistPage,
});
